/**
 * Host de la publication Substack (sin protocolo).
 * Debe responder XML en https://{host}/feed — un perfil @user no sirve.
 */
export const SUBSTACK_PUBLICATION_HOST = 'alejandrosn.substack.com';

/** Subdominio usado en URLs tipo https://{publication}.substack.com/subscribe */
export const SUBSTACK_PUBLICATION =
  SUBSTACK_PUBLICATION_HOST.replace(/\.substack\.com$/i, '') || 'alejandrosn';

/** Perfil público (sin subdominio de pago). Usar en CTAs hacia Substack. */
export const SUBSTACK_PROFILE_URL = 'https://substack.com/@alejandrosn';
